var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsLockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82954 6.29891V4.48436C8.82954 3.11415 7.78126 1.99301 6.5 1.99301C5.21875 1.99301 4.17046 3.11411 4.17046 4.48436V6.29891H2.30685V4.4844C2.30685 2.01799 4.19378 0 6.5 0C8.80622 0 10.6931 2.01799 10.6931 4.4844V6.29891H8.82954ZM13 8.79416V16.4423C13 17.299 12.3445 18 11.5434 18H1.45658C0.65546 18 0 17.299 0 16.4423V8.79413C0 7.93736 0.65546 7.23638 1.45658 7.23638H11.5434C12.3445 7.23638 13 7.9374 13 8.79416ZM7.72494 11.4226C7.72494 10.6991 7.17653 10.1126 6.5 10.1126C5.82347 10.1126 5.27506 10.6991 5.27506 11.4226C5.27506 11.8677 5.48275 12.261 5.80004 12.4977V14.3754C5.80004 14.7871 6.11499 15.1239 6.5 15.1239C6.88501 15.1239 7.19996 14.7871 7.19996 14.3754V12.4977C7.51729 12.2609 7.72494 11.8677 7.72494 11.4226Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsLockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights_lock_icon.863e139fcc76b47768b28d19384ddbe9.svg";